var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1263 20.9583V9.33332H8.04297V20.9583H26.1263ZM26.1263 2.87499C26.8114 2.87499 27.4685 3.14716 27.953 3.63163C28.4375 4.1161 28.7096 4.77318 28.7096 5.45832V20.9583C28.7096 21.6435 28.4375 22.3005 27.953 22.785C27.4685 23.2695 26.8114 23.5417 26.1263 23.5417H8.04297C7.35783 23.5417 6.70074 23.2695 6.21628 22.785C5.73181 22.3005 5.45963 21.6435 5.45963 20.9583V5.45832C5.45963 4.77318 5.73181 4.1161 6.21628 3.63163C6.70074 3.14716 7.35783 2.87499 8.04297 2.87499H9.33463V0.291656H11.918V2.87499H22.2513V0.291656H24.8346V2.87499H26.1263ZM21.6442 13.2858L15.9092 19.0208L12.4476 15.5592L13.8167 14.19L15.9092 16.2825L20.275 11.9167L21.6442 13.2858ZM2.8763 26.125H20.9596V28.7083H2.8763C2.19116 28.7083 1.53408 28.4361 1.04961 27.9517C0.565141 27.4672 0.292969 26.8101 0.292969 26.125V10.625H2.8763V26.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.3d33489750a0eef45bb25a6fe4b3c87a.svg";
export { ForwardRef as ReactComponent };